import React, { useState } from "react";
import { useSelector } from "react-redux";
import ReactDOMServer from "react-dom/server";
import {
  AppMultiSelect,
  AppNotificationAlert,
  AppRemixIcon,
  AppTextArea,
} from "@/layout/AppComponents";
import Translator from "../../../../components/helpers/Translator";
import { Formik } from "formik";
import AppLink from "@/routing/helpers/AppLink";
import { useParams } from "react-router-dom";
import ArchieveFileModal from "./ArchieveFileModal";

const ArchiveFile = () => {
  const { moduleBridgeHex } = useParams();
  const intelligenceProfiles = useSelector(
    (state) => state.currentPage?.intelligenceProfiles,
  );

  const [triggerStartProfileReport, setTriggerStartProfileReport] = useState();

  // > GENERATE PROFILE REPORT
  const handleOnGenerateProfileReport = (values) => {
    setTriggerStartProfileReport(values);
  };

  const handleOnGenerateProfileReportFinish = () => {
    setTriggerStartProfileReport(null);
    AppNotificationAlert({
      title: ReactDOMServer.renderToString(
        <Translator file="module-intelligence" name="finished" />,
      ),
      message: ReactDOMServer.renderToString(
        <Translator
          file="module-intelligence"
          name="reports.saved.correctly"
        />,
      ),
      type: "success",
      position: "top-center",
      duration: 0,
    });
  };
  // > GENERATE PROFILE REPORT

  return (
    <div className="col-4">
      <div className="card">
        <div className="card-header">
          <Translator file="module-intelligence" name="store.reports" />
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-12">
              <Formik
                initialValues={{
                  profiles: [],
                  comment: "",
                }}
                onSubmit={handleOnGenerateProfileReport}
              >
                {({ setFieldValue, handleSubmit, values }) => (
                  <>
                    <div className="row">
                      <div className="col-sm-12">
                        {intelligenceProfiles.length > 0 ? (
                          <AppMultiSelect
                            options={intelligenceProfiles}
                            onChange={(e) => setFieldValue("profiles", e)}
                            title={
                              <Translator
                                file="module-intelligence"
                                name="profile"
                              />
                            }
                            placeholder={ReactDOMServer.renderToString(
                              <Translator
                                file="module-intelligence"
                                name="select.one.or.various.profiles"
                              />,
                            )}
                            icon={<AppRemixIcon icon="inbox-unarchive" />}
                            setValueField="id"
                            setLabelField="name"
                            value={values.profiles}
                            isMulti
                            hasSearchBox
                            hasSelectOptions
                          />
                        ) : (
                          <span className="form-control mb-3" />
                        )}
                      </div>
                    </div>
                    {values.profiles && values.profiles.length > 0 && (
                      <>
                        <div className="row mb-3">
                          <div className="col-lg-12">
                            <AppTextArea
                              title={ReactDOMServer.renderToString(
                                <Translator
                                  file="module-intelligence"
                                  name="description"
                                />,
                              )}
                              icon={<AppRemixIcon icon="chat-quote" />}
                              onChange={(v) => setFieldValue("comment", v)}
                              value={values.comment}
                              isClearable
                            />
                          </div>
                        </div>
                        {values.comment ? (
                          <span
                            className="btn btn-info btn-block"
                            onClick={handleSubmit}
                          >
                            <Translator
                              file="module-intelligence"
                              name="generate.profile.reports"
                            />
                          </span>
                        ) : (
                          <span className="btn btn-info btn-block disabled">
                            <Translator
                              file="module-intelligence"
                              name="generate.profile.reports"
                            />
                          </span>
                        )}
                      </>
                    )}
                  </>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <AppLink
        className="btn btn-outline-light btn-block mt-2"
        path="user_module_intelligence_storedReports"
        params={{ moduleBridgeHex }}
      >
        <AppRemixIcon icon="inbox" size={16} />
        <Translator file="module-intelligence" name="reports.store" />
      </AppLink>
      {triggerStartProfileReport && (
        <ArchieveFileModal
          moduleBridgeHex={moduleBridgeHex}
          values={triggerStartProfileReport}
          setValues={setTriggerStartProfileReport}
          onFinish={handleOnGenerateProfileReportFinish}
        />
      )}
    </div>
  );
};

export default ArchiveFile;
